const onGetProblems = ( status ) => {

    switch ( status ) {
        case 422:
            return {
                status: status,
                message: "recuperare le liste problemi: errore nei parametri di richiesta",
            } 
        default:
            return null;
    }

}

export default onGetProblems;